//
//
//
//

import { dateDifference } from "@Shared/@Utils/helpers/dates";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "RefreshableTimeAgo",
  props: {
    refreshRate: {
      type: Number,
      default: 1000
    },
    date: {
      type: null,
      default: ""
    }
  },
  data() {
    return {
      interval: null,
      timeAgoText: ""
    };
  },
  computed: {
    dateDifferenceInHours() {
      const today = new Date();
      return dateDifference(today, this.date, "hours");
    }
  },
  beforeMount() {
    this.updateTime();
  },
  updated() {
    this.start();
  },
  mounted() {
    if (this.dateDifferenceInHours > 23) this.$nextTick(this.start);
  },
  activated() {
    if (this.dateDifferenceInHours > 23) this.$nextTick(this.start);
  },
  deactivated() {
    this.stop();
  },
  beforeDestroy() {
    this.stop();
  },
  methods: {
    formatTimeAgo() {
      //If we pass undefined to moment, it will take current time so we don't get "Invalid Date"
      return this.$options.filters.formatTimeAgo(this.date || undefined);
    },
    start() {
      this.stop();
      this.interval = setInterval(() => {
        this.updateTime();
      }, this.refreshRate);
    },
    stop() {
      if (this.interval) clearInterval(this.interval);
    },
    updateTime() {
      const formattedTimeAgo = this.formatTimeAgo();
      this.timeAgoText = this.date ? formattedTimeAgo : "Never Saved";
    }
  }
});